/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_passwords_dont_match = /** @type {(inputs: {}) => string} */ () => {
	return `Zkontrolujte, zda se vaše hesla shodují.`
};

const da_account_passwords_dont_match = /** @type {(inputs: {}) => string} */ () => {
	return `Sørg for, at dine adgangskoder stemmer overens.`
};

const de_account_passwords_dont_match = /** @type {(inputs: {}) => string} */ () => {
	return `Bitte stellen Sie sicher, dass die Passwörter übereinstimmen.`
};

const en_account_passwords_dont_match = /** @type {(inputs: {}) => string} */ () => {
	return `Please make sure your passwords match.`
};

const es_account_passwords_dont_match = /** @type {(inputs: {}) => string} */ () => {
	return `Verifica que tus contraseñas coincidan.`
};

const fr_account_passwords_dont_match = /** @type {(inputs: {}) => string} */ () => {
	return `Vérifiez que vos mots de passe concordent.`
};

const hu_account_passwords_dont_match = /** @type {(inputs: {}) => string} */ () => {
	return `Ellenőrizd, hogy a jelszavaid egyeznek-e.`
};

const it_account_passwords_dont_match = /** @type {(inputs: {}) => string} */ () => {
	return `Verifica che le password coincidano.`
};

const nl_account_passwords_dont_match = /** @type {(inputs: {}) => string} */ () => {
	return `Controleer of je wachtwoorden overeenkomen.`
};

const pl_account_passwords_dont_match = /** @type {(inputs: {}) => string} */ () => {
	return `Hasła nie są zgodne.`
};

const pt_account_passwords_dont_match = /** @type {(inputs: {}) => string} */ () => {
	return `Verifique se as senhas coincidem.`
};

const sv_account_passwords_dont_match = /** @type {(inputs: {}) => string} */ () => {
	return `Kontrollera att dina lösenord stämmer överens.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_passwords_dont_match = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_passwords_dont_match(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_passwords_dont_match", locale)
	if (locale === "cs") return cs_account_passwords_dont_match(inputs)
	if (locale === "da") return da_account_passwords_dont_match(inputs)
	if (locale === "de") return de_account_passwords_dont_match(inputs)
	if (locale === "en") return en_account_passwords_dont_match(inputs)
	if (locale === "es") return es_account_passwords_dont_match(inputs)
	if (locale === "fr") return fr_account_passwords_dont_match(inputs)
	if (locale === "hu") return hu_account_passwords_dont_match(inputs)
	if (locale === "it") return it_account_passwords_dont_match(inputs)
	if (locale === "nl") return nl_account_passwords_dont_match(inputs)
	if (locale === "pl") return pl_account_passwords_dont_match(inputs)
	if (locale === "pt") return pt_account_passwords_dont_match(inputs)
	return sv_account_passwords_dont_match(inputs)
};
export { account_passwords_dont_match as "account.passwords_dont_match" }